import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";

export const BrandMarquee = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const BrandMarqueeTrack = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  transition: ${({ $withTransition, $transitionMs }) =>
    $withTransition ? `transform ${$transitionMs}ms ease-in-out` : "none"};
`;

export const BrandGalleryHolder = styled.div`
  flex: 0 0 auto;
  padding: 20px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.maxHeight + 40}px;
  width: ${(props) => props.maxWidth + 60}px;
  img {
    height: ${(props) => props.maxHeight}px;
    width: ${(props) => props.maxWidth}px;
    ${breakpoints.xsDown} {
      width: auto;
      height: auto;
      max-width: 120px;
      max-height: ${(props) => props.maxHeight}px;
    }
  }
  ${breakpoints.smDown} {
    padding: 0 30px;
  }
`;
